// About.js
import React from 'react';
//import AboutMeCard from './AboutMeCard';
import AboutMeSection from './AboutMeSection';

const About = () => {
  return (
    <div>
      <div href="#Aboutme" style={{ textDecoration: 'none' }}> < AboutMeSection /></div>
    </div>
  );
};

export default About;
